import React, { Component } from "react";
import { Layout } from "antd";
import asLogo from "../../img/ASC-logo.png";
import smsLogo from "../../img/sms-logo.png";
import franjas from "../../img/franjas footer.png";
import asxpertLogo from "../../Assets/Images/ASxpert-logo.png";

const { Footer } = Layout;

class ComponenetFooter extends Component {
  render() {
    return (
      <Footer className="footer">
        <div
          style={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <div
            style={{
              backgroundColor: "var(--color-grey-light-1)",
              borderRadius: "2.5rem",
              position: "absolute",
              padding: "0.5rem 5rem"
            }}
          >
            <img src={asxpertLogo} height={55} alt="logo AS Xpert" />
          </div>
          <img src={franjas} height={150} alt="background franjas" />
        </div>
        <a
          href="http://asconsultores.com.mx/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            backgroundColor: "var(--color-grey-light-1)",
            borderRadius: "0.5rem",
            padding: "0 2rem",
            marginTop: "1rem"
          }}
        >
          <div style={{ display: "flex", padding: "1rem" }}>
            <div style={{ borderRight: "1px solid #932A4D" }}>
              <img
                src={asLogo}
                height={40}
                alt="AS Consultores"
                style={{ marginRight: 10 }}
              />
            </div>
            <div style={{ marginLeft: 10 }}>
              <img src={smsLogo} height={40} alt="SMS Latinoamérica" />
            </div>
          </div>
        </a>
        <div style={{ color: "var(--color-grey-light-1)", padding: "1rem" }}>
          AS Consultores ©2018 Developed by{" "}
          <a
            href="https://www.plukketech.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "var(--color-grey-light-1)",
              textDecoration: "none"
            }}
          >
            Plukke
          </a>
        </div>
      </Footer>
    );
  }
}

export default ComponenetFooter;



// WEBPACK FOOTER //
// ./src/Components/Footer/ComponentFooter.js